import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';


@Component({
  selector: 'pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {
  @Input() totalPages: any;
  @Input() currentPage: any;

  @Input() pageSizeVisible: any;
  @Input() pageSize: any;
  
  numberEntriesPage = [10,20,50,100];

  @Output() changePage = new EventEmitter<Object>();
  @Output() changePageSize = new EventEmitter<Object>();


  constructor() { }

  onDecrease(){
    if(this.currentPage > 1)
      this.currentPage = this.currentPage-1;
  }

  onIncrease(){
    if(this.currentPage < this.totalPages)
      this.currentPage = this.currentPage+1;
  }


  valueChange(){
    this.changePage.emit(this.currentPage)
  }


  onChangePageSize(){
    this.changePageSize.emit(this.pageSize)
  }

  ngOnInit(): void {
  }

}
